import dayjs from 'dayjs';
import { AvailabilityScheduleDto } from '../data/models/common/availability';

export const formatMenuTime = (
  availabilitySchedules: AvailabilityScheduleDto[] | undefined
) => {
  if (!availabilitySchedules) return false;

  const now = dayjs();
  const currentDayOfWeek = now.day(); // 0-6, 0 is Sunday

  const todaySchedule = availabilitySchedules.find(
    (schedule) => schedule.dayOfWeek === currentDayOfWeek && schedule.isEnabled
  );

  if (!todaySchedule) return false;
  if (todaySchedule.isAllDay) return true;
  if (!todaySchedule.startTime || !todaySchedule.endTime) return false;
  const startTime = dayjs(todaySchedule.startTime, 'HH:mm:00');
  const endTime = dayjs(todaySchedule.endTime, 'HH:mm:00');

  if (!todaySchedule) return '';
  if (todaySchedule.isAllDay) return 'menu-24-hours';
  if (!todaySchedule.startTime || !todaySchedule.endTime)
    return 'menu-no-schedule';

  return `${startTime.format('HH:mm')} - ${endTime.format('HH:mm')}`;
};

export const isMenuAvailable = (
  availabilitySchedules: AvailabilityScheduleDto[] | undefined
) => {
  if (!availabilitySchedules) return false;

  const now = dayjs();
  const currentDayOfWeek = now.day(); // 0-6, 0 is Sunday
  const currentTime = now.format('HH:mm:00');
  const currentTimeDayjs = dayjs(currentTime, 'HH:mm:00');

  const todaySchedule = availabilitySchedules.find(
    (schedule) => schedule.dayOfWeek === currentDayOfWeek && schedule.isEnabled
  );

  if (!todaySchedule) return false;
  if (!todaySchedule.isEnabled) return false;
  if (todaySchedule.isAllDay) return true;
  if (!todaySchedule.startTime || !todaySchedule.endTime) return false;
  const startTime = dayjs(todaySchedule.startTime, 'HH:mm:00');
  const endTime = dayjs(todaySchedule.endTime, 'HH:mm:00');

  return startTime <= currentTimeDayjs && currentTimeDayjs <= endTime;
};

export const isMenuEnabledForToday = (
  availabilitySchedules: AvailabilityScheduleDto[] | undefined
) => {
  if (!availabilitySchedules) return false;

  const todaySchedule = availabilitySchedules.find(
    (schedule) => schedule.dayOfWeek === dayjs().day() && schedule.isEnabled
  );
  return !!todaySchedule;
};
